import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Briefcase, Activity, Video, FileText, Calendar, Users, DollarSign, UserCheck } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function DashboardStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/admin/stats`, { withCredentials: true });
      setStats(response.data);
    } catch (error) { console.error(error); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4A6B48]"></div>
      </div>
    );
  }

  const cards = [
    { id: 'projects', label: 'Projets', value: stats?.projects, icon: Briefcase, color: '#4A6B48' },
    { id: 'activities', label: 'Activités', value: stats?.activities, icon: Activity, color: '#D87D4A' },
    { id: 'videos', label: 'Vidéos', value: stats?.videos, icon: Video, color: '#4A3728' },
    { id: 'blog', label: 'Articles Blog', value: stats?.blog_posts, icon: FileText, color: '#4A6B48' },
    { id: 'events', label: 'Événements', value: stats?.calendar_events, icon: Calendar, color: '#D87D4A' },
    { id: 'members', label: 'Membres totaux', value: stats?.members, icon: Users, color: '#4A3728' },
    { id: 'pending', label: 'Membres en attente', value: stats?.pending_members, icon: UserCheck, color: '#D87D4A' },
    { id: 'payments', label: 'Paiements reçus', value: stats?.payments, icon: DollarSign, color: '#4A6B48' },
  ];

  return (
    <div data-testid="dashboard-stats">
      <h2 className="text-2xl font-bold text-[#2E332D] mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        Tableau de bord
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((card) => (
          <div key={card.id} className="card" data-testid={`stat-card-${card.id}`}>
            <div className="flex items-center justify-between mb-3">
              <card.icon style={{ color: card.color }} size={28} />
              <span className="text-3xl font-bold text-[#2E332D]">{card.value || 0}</span>
            </div>
            <p className="text-sm text-[#5C665A]">{card.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
